document.addEventListener('DOMContentLoaded', function () {
  // Function to check if the cart is empty and add attributes
  function checkCartAndAddAttributes() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        // Check if the cart was just created (i.e., only one item)
        if (cart.item_count === 1 && !cart.attributes.custom_attribute_1) {
          addCartAttributes({
            'source': 'web'
          });
        }
      })
      .catch(error => console.error('Error checking cart:', error));
  }

  // Function to add attributes to the cart
  function addCartAttributes(attributes) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    })
      .then(response => response.json())
      .then(data => {
        console.log('Cart attributes added:', data);
      })
      .catch(error => console.error('Error adding cart attributes:', error));
  }

  // Event listener for form submissions (for non-AJAX forms)
  document.body.addEventListener('submit', function (event) {
    if (event.target.matches('form[action="/cart/add"]')) {
      setTimeout(checkCartAndAddAttributes, 500);
    }
  });

  // Event listener for AJAX-based "Add to Cart" buttons
  document.body.addEventListener('click', function (event) {
    const button = event.target.closest('.quick-add__submit');
    if (button) {
      // Delay the check to allow the cart to update
      setTimeout(checkCartAndAddAttributes, 500);
    }
  });

  // Listen for Shopify's cart updates (for themes using AJAX)
  document.addEventListener('cart:updated', function () {
    checkCartAndAddAttributes();
  });
});
